import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useBackdrop } from "./useBackdrop";
import { useAlert } from "./useAlert";

export const useProcessingStatus = (isProcessing: boolean, hasError: boolean, message?: string) => {
    const { showBackdrop, hideBackdrop } = useBackdrop();
    const { toggleAlert } = useAlert();
    const { t } = useTranslation();

    useEffect(() => {
        if (hasError) {
            hideBackdrop();

            return toggleAlert({ message: message || t("general.errors.unexpectedError"), type: "error" });
        }

        if (isProcessing) {
            return showBackdrop();
        }

        hideBackdrop();

        // eslint-disable-next-line
    }, [isProcessing, hasError, message]);
};
